export default "__VITE_ASSET__f515e456__"